import React from "react"
import { Layout } from "../components/Layout/Layout"
import { SinglePage } from "../components/SinglePage/SinglePage"
import { NextSeo } from "next-seo"
import { webUrl } from "../config/web"
import { H2 } from "../components/blog/common"
import { ContactForm } from "../components/ContactForm/ContactForm"
import { Section } from "../components/Section"
import { GetStaticProps, GetStaticPropsResult } from "next"
import { getArticlesWithAuthorsByDocumentType, PrismicCustomTypes } from "../lib/prismic/prosmic"
import { dev } from "../lib/dev"
import { PrismicDocument } from "@prismicio/types"
import { getFeedbackAvatarUrl } from "../lib/prismic/courses"
import { Comments } from "../components/Comments/Comments"
import { Space, Typography } from "antd"
import Link from "next/link"

const Recenze = ({ feedbacks }: Props) => {
  const title = "Recenze online programovacích kroužků"
  const description =
    "Recenze rodičů a žáků, kteří se zúčastnili našich počítačových kroužků pro děti. Přihlaste se na kroužky Pythonu, 3D tisku, Scratche nebo Minecraftu."

  const mappedComments = feedbacks.map((d, i) => ({
    avatarImagePath: d.data.image?.url || getFeedbackAvatarUrl(d.data.sex, i),
    photoPath: d.data.photo?.url,
    author: d.data.name?.[0] ? d.data.name?.[0]?.text : "",
    content: d.data.description?.[0] ? d.data.description?.[0]?.text : "",
    dateTime: d.data.forcedFirstPublicationDate || d.first_publication_date
  }))

  return (
    <>
      <NextSeo
        title={title}
        description={description}
        canonical={`${webUrl}/recenze`}
        openGraph={{
          url: `${webUrl}/recenze`,
          title,
          description,
          images: [
            {
              url: `${webUrl}/images/header_laptop.jpg`,
              width: 1920,
              height: 1080,
              alt: "header_laptop"
            }
          ]
        }}
      />

      <Layout>
        <SinglePage title="Recenze online programovacích kroužků">
          <Section>
            <H2 level={2}>Recenze našich rodičů a dětí</H2>

            <Space direction="vertical" size={20}>
              <Typography.Paragraph>
                Líbí se vám naše práce?{" "}
                <Link href="https://g.page/r/CfOxvTup-d7hEBM/review" target="_blank">
                  Ohodnotě nás na našem Google business profilu
                </Link>
                . Děkujeme
              </Typography.Paragraph>

              <Comments comments={mappedComments} />

              <Typography.Paragraph>
                <Link href="https://maps.app.goo.gl/LXi7ZXcZKr4mpcy77" target="_blank">
                  Další recenze najdete zde
                </Link>
                .
              </Typography.Paragraph>
            </Space>
          </Section>

          <Section>
            <H2 level={2}>Kontaktní formulář</H2>
            <ContactForm contactFormName={"Kontakt"} contactFormUrl={`${webUrl}/recenze`} />
          </Section>
        </SinglePage>
      </Layout>
    </>
  )
}

interface Props {
  feedbacks: PrismicDocument<any>[]
}

export const getStaticProps: GetStaticProps = async (): Promise<GetStaticPropsResult<Props>> => {
  const comments = await getArticlesWithAuthorsByDocumentType(PrismicCustomTypes.feedback, undefined, false, false, { pageSize: 20 })

  return {
    props: {
      feedbacks: comments?.results || []
    },
    revalidate: dev ? 1 : 60
  }
}

export default Recenze
